import React, { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { BUTTON_TYPES } from '@evinced-private/ui-common';

import { PlatformPopup } from 'src/common/components/platform-popup/PlatformPopup';

interface IReportNotFoundPopupProps {
	title: string;
	text: string;
	stateKey: string;
}

export const ReportNotFoundPopup: FC<IReportNotFoundPopupProps> = ({ title, text, stateKey }) => {
	const history = useHistory();
	const [isOpen, setIsOpen] = useState(history.location?.state?.[stateKey]);

	const handleClose = (): void => setIsOpen(false);

	useEffect(() => {
		history.replace({ state: { [stateKey]: false } });
	}, [history, stateKey]);

	return (
		<PlatformPopup
			title={title}
			isControlled
			isBgTransparent
			isOpen={isOpen}
			popupWidth={480}
			onClose={handleClose}
			buttons={[
				{
					type: BUTTON_TYPES.SECONDARY,
					title: 'Cancel',
					onClick: (onClose) => onClose()
				},
				{
					title: 'OK',
					onClick: (onClose) => {
						onClose();
						window.location.reload();
					}
				}
			]}
		>
			{text}
		</PlatformPopup>
	);
};
